
export const initialState = {
  transTypes: {
    data: [],
    isLoading: false
  },
};
